


  
  

  var faLightCalendarCircleArrowLeft = {
    prefix: 'fak',
    iconName: 'light-calendar-circle-arrow-left',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M0 128C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 6.6c-11.2 3.2-21.9 7.4-32 12.6l0-19.2L32 192l0 256c0 17.7 14.3 32 32 32l296.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32zm32 0l0 32 384 0 0-32c0-17.7-14.3-32-32-32L64 96c-17.7 0-32 14.3-32 32zM352 368.1c0-51.4 27.4-99 72-124.7s99.4-25.7 144 0s72 73.3 72 124.7s-27.4 99-72 124.7s-99.4 25.7-144 0s-72-73.3-72-124.7zm32 0c0 40 21.3 77 56 97s77.3 20 112 0s56-57 56-97s-21.3-77-56-97s-77.3-20-112 0s-56 57-56 97zm36.7-11.4l56-56c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 352l89.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-89.4 0 28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 .1l-56-56c-6.3-6.3-6.3-16.4 0-22.7z'
      
    ]
  };

  

  
  

  var faSharpSolidGameConsoleHandheldCircleXmark = {
    prefix: 'fak',
    iconName: 'sharp-solid-game-console-handheld-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e001',
      
      'M0 0L384 0l0 198.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM64 320l0 32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-32-32 0 0 32-32 0zM96 64l0 160 192 0 0-160L96 64zM208 360c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24zm80 8c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm73.4-48l48 48-48 48L384 438.6l48-48 48 48L502.6 416l-48-48 48-48L480 297.4l-48 48-48-48L361.4 320z'
      
    ]
  };

  

  
  

  var faSolidGameBoardSimpleCircleXmark = {
    prefix: 'fak',
    iconName: 'solid-game-board-simple-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 102.6c-23.8 6.7-45.5 18.3-64 33.6L384 96 224 96l0 160 136.2 0C335.1 286.4 320 325.5 320 368s15.1 81.6 40.3 112L64 480c-35.3 0-64-28.7-64-64L0 96zM64 256l0 160 160 0 0-160L64 256zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm84.7-59.3c-6.2 6.2-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  



export {

  faLightCalendarCircleArrowLeft,
  

  faSharpSolidGameConsoleHandheldCircleXmark,
  

  faSolidGameBoardSimpleCircleXmark,
  

};
